/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Restart_BodyInputs */

const en_us2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The week count starts again today, to begin a new block with the same workouts. Your exercises and history stay as they are.`)
};

const pt_br2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A contagem de semanas recomeça hoje, para começar um novo ciclo com os mesmos treinos. Os exercícios e o seu histórico continuam como estão.`)
};

const es_419_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El conteo de semanas vuelve a empezar hoy, para iniciar un nuevo bloque con los mismos entrenamientos. Tus ejercicios y tu historial quedan como están.`)
};

const pt_pt2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A contagem de semanas recomeça hoje, para começar um novo ciclo com os mesmos treinos. Os exercícios e o teu histórico ficam como estão.`)
};

const fr_fr2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le décompte des semaines repart aujourd'hui, pour commencer un nouveau bloc avec les mêmes séances. Tes exercices et ton historique restent tels quels.`)
};

const de_de2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Wochenzählung beginnt heute neu, für einen neuen Block mit denselben Trainings. Deine Übungen und dein Verlauf bleiben, wie sie sind.`)
};

const it_it2_plan_build_restart_body = /** @type {(inputs: Plan_Build_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il conteggio delle settimane riparte da oggi, per iniziare un nuovo ciclo con gli stessi allenamenti. Gli esercizi e lo storico restano come sono.`)
};

/**
* | output |
* | --- |
* | "The week count starts again today, to begin a new block with the same workouts. Your exercises and history stay as they are." |
*
* @param {Plan_Build_Restart_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_restart_body = /** @type {((inputs?: Plan_Build_Restart_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Restart_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_restart_body(inputs)
	if (locale === "es-419") return es_419_plan_build_restart_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_restart_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_restart_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_restart_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_restart_body(inputs)
	return en_us2_plan_build_restart_body(inputs)
});
export { plan_build_restart_body as "plan-build.restart_body" }